/**
 * Quel espace ce build sert-il ?
 *
 * L'administration et l'espace organisateur partagent ce code, mais pas leur
 * public : les administrateurs sont du personnel interne, les organisateurs
 * des clients. Les servir depuis une même adresse obligeait à donner
 * l'adresse de l'administration à chaque organisateur — et à livrer dans le
 * même bundle les écrans chauffeurs, courses et finances.
 *
 * La valeur est figée à la construction (`REACT_APP_ESPACE`) : react-scripts
 * la remplace dans le bundle, elle ne peut pas être changée à l'exécution.
 * En développement, sans variable, on sert l'administration.
 */
export const ESPACE_ORGANISATEUR = "organisateur";
export const ESPACE_ADMIN = "admin";

export const ESPACE =
  process.env.REACT_APP_ESPACE === ESPACE_ORGANISATEUR
    ? ESPACE_ORGANISATEUR
    : ESPACE_ADMIN;

export const estEspaceOrganisateur = ESPACE === ESPACE_ORGANISATEUR;
export const estEspaceAdmin = ESPACE === ESPACE_ADMIN;

/** Écran de connexion de l'espace servi. */
export const cheminConnexion = estEspaceOrganisateur
  ? "/login-organizer"
  : "/login";

/**
 * Rôle porté par la session, lu dès le premier rendu.
 *
 * Chaque écran le lisait dans un `useEffect`, avec `useState("")` pour valeur
 * de départ : le premier rendu croyait donc toujours avoir affaire à un
 * administrateur. Dans l'espace organisateur, le menu complet de
 * l'administration s'affichait le temps d'une image, et les écrans qui
 * bifurquent sur le rôle montraient d'abord leur version administrateur —
 * déclenchant au passage des appels que le serveur refuse.
 *
 * Dans l'espace organisateur, la réponse est « ORGANISATEUR » quoi que porte
 * la session : ce build ne sert que cet espace.
 */
export const lireRoleSession = () => {
  if (estEspaceOrganisateur) return "ORGANISATEUR";
  try {
    const brut = localStorage.getItem("authUser");
    return brut ? JSON.parse(brut).role || "" : "";
  } catch (e) {
    return "";
  }
};
